export default [
  //ACTIVITY SECTION
  {
    path: "/activity/townships",
    name: "activity-township",
    component: () => import("@/views/activity/Township.vue"),
    meta: {
      forAuth: true,
    },
  },
  {
    path: "/activity/:township_id",
    name: "activity",
    component: () => import("@/views/activity/Activity.vue"),
    meta: { forAuth: true },
  },
  {
    path: "/activity-list/:month/:year/:township_id",
    name: "activity-list",
    component: () => import("@/views/activity/ActivityList.vue"),
    meta: { forAuth: true },
  },
  // HE ACTIVITY SECTION
  {
      path: "/create/he/activity/:month/:year/:township_id",
      name: "create-he",
      component: () =>
          import ("@/views/activity/HE/Create.vue"),
      meta: { forAuth: true, },
  },

  {
    path: "/he/activity/:month/:year/:township_id",
    name: "he",
    component: () => import("@/views/activity/HE/HeAct.vue"),
    meta: {
      forAuth: true,
      //Breadcumps
      breadcrumps: [
        { text: "activity", to: "-2" },
        { text: "activity list", to: "-1", params: true },
      ],
    },
  },
  {
    path: "/edit/he/activity/:id/:month/:year/:township_id",
    name: "edit-he",
    component: () => import("@/views/activity/HE/Edit.vue"),
    meta: { forAuth: true },
  },
  // HOME VISIT ACTIVITY SECTION
  {
    path: "/home-visit/activity/:month/:year/:township_id",
    name: "home-visit",
    component: () => import("@/views/activity/home-visit/HomeVisitAct.vue"),
    meta: {
      forAuth: true,
      //Breadcumps
      breadcrumps: [
        { text: "activity", to: "-2" },
        { text: "activity list", to: "-1" },
      ],
    },
  },
  {
    path: "/edit/home-visit/activity/:id/:month/:year",
    name: "edit-home-visit",
    component: () => import("../../views/activity/home-visit/Edit.vue"),
    meta: { forAuth: true },
  },
  // SUPERVISION ACTIVITY SECTION/
  {
    path: "/supervision-visit/activity/:month/:year/:township_id",
    name: "supervision-visit",
    component: () => import("@/views/activity/supervision/SuperVisionAct.vue"),
    meta: {
      forAuth: true,
      //Breadcumps
      breadcrumps: [
        { text: "activity", to: "-2" },
        { text: "activity list", to: "-1" },
      ],
    },
  },
  {
    path: "/edit/supervision-visit/activity/:id/:month/:year",
    name: "edit-supervision-visit",
    component: () => import("@/views/activity/supervision/Edit.vue"),
    meta: { forAuth: true },
  },
  // COUNSELING ACTIVITY SECTION
  {
    path: "/counseling/activity/:month/:year/:township_id",
    name: "counseling",
    component: () => import("@/views/activity/counseling/CounselingAct.vue"),
    meta: {
      forAuth: true,
      breadcrumps: [
        { text: "activity", to: "-2" },
        { text: "activity list", to: "-1" },
      ],
    },
  },
  {
    path: "/edit/counseling/activity/:id/:month/:year",
    name: "edit-counseling",
    component: () => import("@/views/activity/counseling/Edit.vue"),
    meta: {
      forAuth: true,
    },
  },
  
];
